import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Form } from "antd";
import { useState } from "react";
import { calculateSafetyMechanismsFromSpecialTreatments } from "@devowl-wp/react-cookie-banner";
import { jsxJoin } from "@devowl-wp/react-utils";
import { useFormService } from "../../../../../contexts/formService.js";
import { useI18n } from "../../../../../contexts/i18n.js";
import { useServiceDataProcessingCountriesSpecialTreatments } from "../../../../../hooks/useServiceDataProcessingCountriesSpecialTreatments.js";
import { useTerritorialLegalBasisArticles } from "../../../../../hooks/useTerritorialLegalBasisArticles.js";
import { FormValueDifferFromTemplateTag, diffByJsonStringify } from "../../../valueDifferFromTemplateTag.js";
const FormServiceFieldGeneralDataProcessingCountriesSpecialTreatment = ()=>{
    const { __, _i } = useI18n();
    const { iso3166OneAlpha2, territorialLegalBasis, predefinedDataProcessingInSafeCountriesLists } = useFormService();
    const [ref, setRef] = useState();
    const specialTreatments = useServiceDataProcessingCountriesSpecialTreatments({
        __,
        _i,
        predefinedDataProcessingInSafeCountriesLists,
        iso3166OneAlpha2,
        territorialLegalBasis
    });
    const { dataProcessingInUnsafeCountriesArticles, dataProcessingInUnsafeCountriesArticlesLinks } = useTerritorialLegalBasisArticles({
        predefinedDataProcessingInSafeCountriesLists,
        iso3166OneAlpha2
    })(territorialLegalBasis);
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>JSON.stringify(prevValues.dataProcessingInCountries) !== JSON.stringify(nextValues.dataProcessingInCountries) || JSON.stringify(prevValues.dataProcessingInCountriesSpecialTreatments) !== JSON.stringify(nextValues.dataProcessingInCountriesSpecialTreatments),
        children: ({ getFieldValue })=>{
            const dataProcessingInCountries = getFieldValue("dataProcessingInCountries");
            const dataProcessingInCountriesSpecialTreatments = getFieldValue("dataProcessingInCountriesSpecialTreatments");
            const { unsafeCountries, allowedSpecialTreatments } = calculateSafetyMechanismsFromSpecialTreatments({
                territorialLegalBasis,
                predefinedDataProcessingInSafeCountriesLists,
                service: {
                    dataProcessingInCountries,
                    dataProcessingInCountriesSpecialTreatments
                }
            });
            const specialTreatmentOptions = specialTreatments.filter(({ value })=>allowedSpecialTreatments.indexOf(value) > -1);
            return /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Safety mechanisms for data transmission"),
                style: {
                    display: allowedSpecialTreatments.length === 0 ? "none" : undefined
                },
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        ref: setRef,
                        style: {
                            margin: "0px 0px 10px 0px"
                        },
                        children: _i(__("You have selected countries which are considered as unsafe (%s). If you activate one of this safety mechanisms, you do not ask for consent according to {{article/}}, if this kind of consent is activated at all in the settings.", unsafeCountries.map((country)=>iso3166OneAlpha2[country]).join(", ")), {
                            article: jsxJoin(dataProcessingInUnsafeCountriesArticles.map((article, i)=>{
                                return /*#__PURE__*/ _jsx("a", {
                                    href: dataProcessingInUnsafeCountriesArticlesLinks[i],
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: article
                                }, article);
                            }), __(" or "))
                        })
                    }),
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "dataProcessingInCountriesSpecialTreatments",
                        noStyle: true,
                        children: /*#__PURE__*/ _jsx(Checkbox.Group, {
                            options: specialTreatmentOptions
                        })
                    }),
                    /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                        form: "service",
                        valueName: "dataProcessingInCountriesSpecialTreatments",
                        widthOfRef: ref,
                        style: {
                            marginTop: 10
                        },
                        difference: (oldValue, newValue)=>diffByJsonStringify(oldValue.filter((e)=>allowedSpecialTreatments.indexOf(e) > -1), newValue.filter((e)=>allowedSpecialTreatments.indexOf(e) > -1)),
                        renderDiff: (value)=>{
                            return /*#__PURE__*/ _jsx(Checkbox.Group, {
                                options: specialTreatmentOptions,
                                value: value,
                                disabled: true
                            });
                        }
                    })
                ]
            });
        }
    });
};
export { FormServiceFieldGeneralDataProcessingCountriesSpecialTreatment };
